module.exports = __webpack_public_path__ + "static/media/apt-logo.f77b0448.svg";